// @ts-check
import { gql } from '@apollo/client/core';
import { Image } from '@react-pdf/renderer';
import { useProduct } from './UrbanihofInfoSheet';
import React from 'react';

export default function UrbanihofInfoSheetBottleImage({ style, ...rest }) {
  const product = useProduct();
  if (!product.bottleImage?.fixed?.src) return null;
  return (
    <Image
      src={product.bottleImage.fixed.src}
      style={[
        {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'right bottom',
        },
        style,
      ]}
      {...rest}
    />
  );
}

UrbanihofInfoSheetBottleImage.fragment = gql`
  fragment UrbanihofInfoSheetBottleImage on Product {
    productId
    bottleImage {
      # 50mm * 2.54 / 72dpi * 300dpi
      fixed(width: 529) {
        src
      }
    }
  }
`;
